import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=1deb7caf&scoped=true&"
import script from "./NotificationHandler.vue?vue&type=script&lang=js&"
export * from "./NotificationHandler.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=1deb7caf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb7caf",
  null
  
)

export default component.exports